import ProductMiniCartView from './product-mini-cart-view'

export default ProductMiniCartView
